import { useMemo } from "react";
import type { DashboardContext, DashboardFacetKey } from "./dashboard-kinds";
import { ProjectActivity } from "./ProjectActivity";
import { parseRequirements } from "./project-plan";
import { ProjectGuidedTeamScreen } from "./screens/ProjectGuidedTeamScreen";

// Die Flächen, die jede Art gleich trägt: das Anforderungsprofil (`data.requirements`, dieselbe
// Sprache wie im Match) und die Aktivität. Die Flächen einer Art (ProjectFacetView,
// ListingFacetView) reichen alles hierher weiter, was sie nicht selbst zeichnen.
export function CommonFacetView({ facet, ctx }: { facet: DashboardFacetKey; ctx: DashboardContext }) {
  const requirements = useMemo(() => parseRequirements(ctx.data.requirements), [ctx.data.requirements]);
  if (facet === "team") {
    return (
      <ProjectGuidedTeamScreen
        mode={ctx.config.toMatch.modes[0]}
        requirements={requirements}
        onChange={(next) => ctx.editData({ requirements: next })}
        readOnly={ctx.readOnly}
      />
    );
  }
  if (facet === "ablauf") return <ProjectActivity items={ctx.activity} empty={ctx.config.texts.activityEmpty} />;
  return null;
}
